import React from 'react'
import EmployeeCard from './EmployeeCard'

const ListEmployees = ({ store, employees, removeEmployee }) => {
  return employees.map(e => (
    <EmployeeCard
      key={e.id}
      store={store}
      employee={e}
      removeEmployee={removeEmployee}
    />
  ))
}

export default ListEmployees
